import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function Locked({ feature = "this feature" }) {
  return (
    <div className="sb-card p-8 text-center max-w-lg mx-auto mt-6 fade-up" data-testid="locked-feature">
      <div className="mx-auto h-14 w-14 rounded-2xl bg-[#F5F0E6] flex items-center justify-center mb-4"><Lock className="h-6 w-6 text-[#1E2B3C]" /></div>
      <h2 className="text-xl font-bold">Unlock {feature}</h2>
      <p className="text-sm text-[#5C6B73] mt-2">This is part of Sidebizz Business Builder — the guided journey from idea to launch.</p>
      <Link to="/upgrade" className="sb-btn-primary mt-6 w-full" data-testid="locked-upgrade-btn">See Business Builder</Link>
    </div>
  );
}

export function Gate({ perm, feature, children }) {
  const { can } = useAuth();
  return can(perm) ? children : <Locked feature={feature} />;
}
